import { Container } from "@mui/material";
import HeaderBreadcrumbs from "components/HeaderBreadcrumbs";
import Page from "components/Page";
import useSettings from "hooks/useSettings";
import ModulesFormContainer from "../../../../components/_dashboard/modules-content/ModulesFormContainer";

export default function AddEditModulesContent() {
  const { themeStretch } = useSettings();

  return (
    <Page title="Add Edit Journey Table">
      <Container maxWidth={themeStretch ? false : "lg"}>
        <HeaderBreadcrumbs heading={"Modules content"} links={[]} />

        <ModulesFormContainer />
      </Container>
    </Page>
  );
}
